import client1 from "../Images/client/header-A.jpg";
import client2 from "../Images/client/pmgsy-logo.png";
import client3 from "../Images/client/Screenshot 2025-10-26 171541.png";
import client4 from "../Images/client/Screenshot 2025-10-26 172137.png";
import client5 from "../Images/client/Screenshot 2025-10-26 172155.png";
import client6 from "../Images/client/WhatsApp Image 2025-10-27 at 21.56.25_f9925ee1.jpg";

export const clients = [
  {
    name: "Public Works Department (PWD)",
    image: client4,
    category: "Government"
  },
  {
    name: "Pradhan Mantri Gram Sadak Yojana (PMGSY)",
    image: client2,
    category: "Government"
  },
  {
    name: "Marcoline Industries",
    image: client3,
    category: "Private"
  },
  {
    name: "Cube Highways",
    image: client5,
    category: "Private"
  },
  {
    name: "National Highways Authority of India (NHAI)",
    image: client6,
    category: "Government"
  }
];
